import { useMutation, useQueryClient } from "@tanstack/react-query"
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { login as LoginAPI } from "services/apiAuth"

const useLogin = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

  const{isPending, mutate: login} = useMutation({
    mutationFn: (app_code) => LoginAPI(app_code),
    onSuccess:(data)=>{
        // console.log("data on uselogin:",data);
        localStorage.setItem("authUser",JSON.stringify(data.prospect))
        const count = data.count.count ?? 0;
        localStorage.setItem("count",JSON.stringify(count))
        queryClient.setQueryData(["authUser"],data);
        toast.success("Login Successful")
        navigate('/dashboard', {replace:true})
        
    },
    onError:(error)=> {
        console.log("error:",error)
        toast.error("Invalid App Code")
    }
  })
  return {isPending, login}
}

export default useLogin